import { render, staticRenderFns } from "./detailIntroduce.vue?vue&type=template&id=3c7f5c12&scoped=true&"
import script from "./detailIntroduce.vue?vue&type=script&lang=js&"
export * from "./detailIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./detailIntroduce.vue?vue&type=style&index=0&id=3c7f5c12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7f5c12",
  null
  
)

export default component.exports